/**
 * Whether a candidate account is the signed-in user, compared on the uuid every impersonation payload
 * already carries (`User.id`, the admin-search `uuid`, the company-user `id`) and that `changeUser`
 * targets — so a missing id breaks the flow itself rather than letting this pass silently.
 */
export const isSelfUser = (currentUserId: string | null | undefined, candidateId: string | null | undefined): boolean =>
  Boolean(currentUserId && candidateId && currentUserId === candidateId);
